var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthBackgroundXsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 251,
    viewBox: "0 0 141 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.1693 58.5017L95.683 59.9477L95.683 62.8239L95.6829 164.481L95.6829 167.358L98.1693 168.804L185.561 219.627L188.075 221.089L190.588 219.627L277.98 168.804L280.467 167.358L280.467 164.481L280.467 62.8239L280.467 59.9477L277.98 58.5017L190.589 7.67793L188.075 6.21609L185.561 7.67792L98.1693 58.5017Z",
    fill: "#FFC107",
    stroke: "white",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4862 222.197L4.99985 223.643L4.99985 226.519L4.99984 328.176L4.99984 331.052L7.48619 332.498L94.8781 383.322L97.3917 384.784L99.9054 383.322L187.297 332.498L189.784 331.052L189.784 328.176L189.784 226.519L189.784 223.643L187.297 222.197L99.9054 171.373L97.3918 169.911L94.8781 171.373L7.4862 222.197Z",
    fill: "#171717",
    stroke: "white",
    strokeWidth: 10,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthBackgroundXsNew);
export default __webpack_public_path__ + "static/media/AuthBackgroundXSNew.617e978f01ea001bfb57d7d75db7a49c.svg";
export { ForwardRef as ReactComponent };